import React, { useState } from 'react';
import './InteractiveCard.css';

const InteractiveCard = ({
  image,
  message,
  cardType,
  offerDescription,
  termsConditions,
  businessName,
  businessLocation
}) => {
  const [flipped, setFlipped] = useState(false);

  return (
    <div className="card-wrapper">
      <div className={`card-inner ${flipped ? 'flipped' : ''}`}>
        {/* Front of the card (AI-generated image) */}
        <div className="card-face card-front">
          <img src={image} alt="Puzzle Card Front" className="card-image" />
        </div>

        {/* Back of the card (Message + Optional Offer Info) */}
        <div className="card-face card-back">
          <div className="card-message">
            <p>{message}</p>

            {cardType === 'Coupon/Offer' && (
              <div className="coupon-info">
                <h3>{offerDescription}</h3>
                <p><strong>Business:</strong> {businessName}</p>
                <p><strong>Location:</strong> {businessLocation}</p>
                <p><strong>Terms:</strong> {termsConditions}</p>
              </div>
            )}
          </div>
        </div>
      </div>

      {!flipped && (
        <button className="flip-button" onClick={() => setFlipped(true)}>
          Click Here to Flip
        </button>
      )}
    </div>
  );
};

export default InteractiveCard;
